import { sidebarSubmenu } from 'components/UI/layout/components/dashboardSidebar/SidebarMenu';

export const partOfRoute = (str: string): string => {
  const questionMarkIndex = str.indexOf('?');
  const slashIndex = str.indexOf('/');

  // If the delimiter is not found, return the original string
  if (questionMarkIndex === -1 && slashIndex === -1) {
    return str;
  }

  // Determine the index of the first delimiter
  const delimiterIndex = questionMarkIndex !== -1 && slashIndex !== -1 ? Math.min(questionMarkIndex, slashIndex) : Math.max(questionMarkIndex, slashIndex);

  // Return the substring before the delimiter
  return str.substring(0, delimiterIndex);
};

export const isMenuSelected = (customLink: string, pathname: string) => {
  return partOfRoute(customLink.replace('/dashboard/', '')) === partOfRoute(pathname.replace('/dashboard/', ''));
};

export const isAnySubMenusSelected = (pathname: string, subMenu?: sidebarSubmenu[]) => {
  if (!subMenu) return false;
  return subMenu.some((item) => isMenuSelected(item.to, pathname));
};
